import { Component, EventEmitter, OnInit, OnChanges, OnDestroy, Output, Input, ViewChild, SimpleChanges } from '@angular/core';
import { DropzoneComponent, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';

import { MatDialog } from '@angular/material/dialog';

import { ToastrService } from 'ngx-toastr';

import { DialogComponent } from '../../ui/dialog/dialog';
import { DialogLightComponent } from '../../ui/dialog-light/dialog-light';

import { WorkoutProvider } from '../../providers/workout/workout';
import { GoalProvider } from '../../providers/goal/goal';
import { ApiProvider } from '../../providers/api/api';
import { LibraryProvider } from '../../providers/library/library';
import { HelpersProvider } from '../../providers/helpers/helpers';
import { I18nProvider } from '../../providers/i18n/i18n';

import { environment } from '../../environments/environment';
import {
  isModernLayoutTheme,
  LAYOUT_THEME_STORAGE_KEY,
  layoutThemeChanges$,
  normalizeLayoutTheme,
} from '../../providers/layout-theme/layout-theme';

@Component({
  selector: 'app-block-workouts',
  templateUrl: 'workouts.html',
})
export class WorkoutsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() training_id: any;
  @Input() cloned_library: any = null;
  @Input() opened_library: boolean = false;
  @Input() workout_id = 0;
  @Input() ismobile: boolean = false;
  @Input() istablet: boolean = false;
  @Input() reset: boolean = false;
  @ViewChild('dzWorkoutCover', {static: false}) dzWorkoutCover?: DropzoneComponent;
  @ViewChild('workoutForm', {static: false}) workoutForm: HTMLFormElement;
  @ViewChild('checkAll') checkAll: HTMLFormElement;
  @Output() setWorkoutId = new EventEmitter();
  @Output() setOpenLibrary = new EventEmitter();

  STRINGS: any;
  PAGE: any;

  protected limit: number = 25;
  protected headers: any;
  protected API = (environment.API_ENV_URLS).replace('/api', '/');

  @Input() workout: any = {
    id: <number> 0,
    cover_url: <string> null,
    cover_path: <string> null,
    video_url: <string> 'https://player.vimeo.com/video/',
    name: <string> null,
    description: <string> null,
    series_repetitions: <string> null,
    weight_suggestion: <string> null,
    intervals: <number> null,
    sort: <number> 0,
    training_id: <number> 0,
    translations: <string> '',
  };

  user: any = {};
  workouts: any = [];
  total_workouts = 0;
  total_workouts_without_series = 0;
  selected_workout = 0;
  sanitized_video_url: any;
  library: any = [];

  loading: boolean;
  loadingLibrary: boolean;
  call_form = 0;
  showSerieForm: boolean = false;
  serieWorkout: any;

  serieForm = new FormGroup({
    id: new FormControl('0'),
    name: new FormControl('', [Validators.required]),
    training_id: new FormControl('', [Validators.required]),
    description: new FormControl('', [Validators.required]),
    color: new FormControl('#707070', [Validators.required]),
    selected: new FormControl('0', [Validators.required]),
    translations: new FormControl(''),
  });

  workoutName = new FormControl('', [Validators.required]);
  workoutVideoUrl = new FormControl('', [Validators.required]);

  public config: DropzoneConfigInterface;

  checkAllComplete: boolean = false;
  checkAllIndeterminate: boolean = false;
  total_selected = 0;
  selected_workouts = [];

  quickWorkoutSuggestions: any = {
    series_repetitions: [
      { label: 'preset_series_3x12', value: '3x12' },
      { label: 'preset_series_4x10', value: '4x10' },
      { label: 'preset_series_3x8_10', value: '3x8-10' },
      { label: 'preset_series_5x5', value: '5x5' },
      { label: 'preset_series_4x20', value: '4x20' },
    ],
    intervals: [
      { label: 'preset_interval_30', value: 30 },
      { label: 'preset_interval_45', value: 45 },
      { label: 'preset_interval_60', value: 60 },
      { label: 'preset_interval_90', value: 90 },
      { label: 'preset_interval_120', value: 120 },
      { label: 'preset_interval_180', value: 180 },
    ],
    weight_suggestion: [
      { label: 'preset_weight_body', value: 'preset_weight_body_value' },
      { label: 'preset_weight_light', value: 'preset_weight_light_value' },
      { label: 'preset_weight_moderate', value: 'preset_weight_moderate_value' },
      { label: 'preset_weight_heavy', value: 'preset_weight_heavy_value' },
      { label: 'preset_weight_20kg', value: 'preset_weight_20kg_value' },
      { label: 'preset_weight_40kg', value: 'preset_weight_40kg_value' },
    ],
  };

  modernLayoutTheme = false;
  selectedSerieMethod: any;
  readonly serieColors: string[] = [
    '#ff6b6b', '#ff9d2e', '#ffb454', '#ffe066', '#5fd989',
    '#4fd6d6', '#7fb3ff', '#c084ff', '#ff7fc4', '#9a9ea6'
  ];
  readonly serieMethods: any[] = [
    {
      key: 'super', icon: '🔥', name: 'Super-Série', sub: '2 exercícios', color: '#ff6b6b',
      names: ['Super-Série', 'Super-Série Antagonista', 'Super-Série A'],
      descriptions: [
        { label: 'Padrão', text: 'Execute os exercícios em sequência sem descanso entre eles. Descanse apenas após concluir todos os exercícios do grupo.' },
        { label: 'Antagonistas', text: 'Dois exercícios de grupos musculares antagonistas, executados um após o outro sem pausa. O intervalo indicado vale para depois de completar a dupla.' },
        { label: 'Curta', text: 'Sem descanso entre os exercícios. Descanse só ao final da dupla.' },
      ]
    },
    {
      key: 'bi', icon: '⚡', name: 'Bi-Set', sub: '2 exercícios', color: '#ff9d2e',
      names: ['Bi-Set', 'Bi-Set Mesmo Grupo', 'Bi-Set Pré-Exaustão'],
      descriptions: [
        { label: 'Padrão', text: 'Execute 2 exercícios consecutivos sem intervalo entre eles. Ótimo para aumentar o volume e intensidade em menos tempo.' },
        { label: 'Mesmo grupo', text: 'Dois exercícios seguidos para o mesmo grupo muscular, sem descanso entre eles, aumentando o tempo sob tensão.' },
        { label: 'Pré-exaustão', text: 'Execute o primeiro exercício até a técnica começar a falhar e emende imediatamente no segundo, sem pausa.' },
      ]
    },
    {
      key: 'tri', icon: '🔺', name: 'Tri-Set', sub: '3 exercícios', color: '#ffb454',
      names: ['Tri-Set', 'Tri-Set Membros Superiores', 'Tri-Set Membros Inferiores'],
      descriptions: [
        { label: 'Padrão', text: 'Execute 3 exercícios em sequência sem descanso. Descanse somente após finalizar os 3 movimentos. Alto volume e estímulo metabólico.' },
        { label: 'Detalhada', text: 'Encadeie os três exercícios sem pausa entre eles. O intervalo indicado é aplicado apenas depois de completar o trio.' },
      ]
    },
    {
      key: 'giant', icon: '💪', name: 'Giant-Set', sub: '4+ exercícios', color: '#c084ff',
      names: ['Giant-Set', 'Giant-Set Circuito de Força'],
      descriptions: [
        { label: 'Padrão', text: 'Encadeie 4 ou mais exercícios sem pausa entre eles. Excelente para condicionamento e hipertrofia em circuito de alta densidade.' },
        { label: 'Curta', text: 'Quatro ou mais exercícios em sequência, sem descanso, repetindo pelo número de rounds indicado.' },
      ]
    },
    {
      key: 'circuit', icon: '🔄', name: 'Circuito', sub: 'Estações', color: '#7fb3ff',
      names: ['Circuito de Exercícios', 'Circuito Metabólico', 'Circuito Funcional'],
      descriptions: [
        { label: 'Padrão', text: 'Realize cada exercício como uma estação, avançando para o próximo com pouco ou nenhum descanso. Complete todas as estações e repita o número de voltas indicado.' },
        { label: 'Metabólico', text: 'Percorra todos os exercícios em sequência formando um round. Anote o tempo ou repetições de cada round para acompanhar sua evolução.' },
      ]
    },
    {
      key: 'stretch', icon: '🧘', name: 'Alongamento', sub: 'Flexibilidade', color: '#5fd989',
      names: ['Sessão de Alongamento', 'Mobilidade e Flexibilidade'],
      descriptions: [
        { label: 'Padrão', text: 'Execute cada exercício com suavidade e controle, sustentando a posição pelo tempo indicado. Respire profundamente e relaxe progressivamente a musculatura.' },
        { label: 'Mobilidade', text: 'Exercícios de mobilidade articular para melhorar a amplitude de movimento. Execute sem dor, apenas até sentir o alongamento.' },
      ]
    },
    {
      key: 'drop', icon: '📉', name: 'Drop-Set', sub: 'Redução de carga', color: '#ff8c94',
      names: ['Drop-Set'],
      descriptions: [
        { label: 'Padrão', text: 'Execute o exercício até a falha, reduza a carga imediatamente e continue sem descanso. Repita as reduções conforme indicado. Excelente para hipertrofia máxima.' },
        { label: 'Curta', text: 'Na falha, reduza o peso e continue sem descanso, repetindo o número de quedas indicado.' },
      ]
    },
    {
      key: 'iso', icon: '🧱', name: 'Isometria', sub: 'Contração estática', color: '#4fd6d6',
      names: ['Série Isométrica'],
      descriptions: [
        { label: 'Padrão', text: 'Mantenha a contração muscular estática na posição indicada pelo tempo prescrito, sem mover a articulação. Foco total na tensão muscular e respiração controlada.' },
      ]
    },
    { key: 'custom', icon: '✏️', name: 'Personalizado', sub: 'Livre', color: '#9a9ea6', names: [], descriptions: [] },
  ];

  private layoutThemeSubscription: Subscription;

  private lastLoadedTid: any = null;
  private needsReload: boolean = false;

  cropCheckInterval: any;

  constructor(
    public toastr: ToastrService,
    public workoutProvider: WorkoutProvider,
    public goalProvider: GoalProvider,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    public libraryProvider: LibraryProvider,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('ExerciciosPage');

    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};
    this.user = JSON.parse(localStorage.getItem('user'));
    // console.log('constructor:');

    this.config = {
      paramName: 'cover_img',
      thumbnailMethod: 'contain',
      thumbnailHeight: null,
      thumbnailWidth: null,
      addRemoveLinks: true,
      dictRemoveFile: this.STRINGS.dz_remover_imagem,
      dictCancelUpload: this.STRINGS.dz_cancelar_envio,
      dictCancelUploadConfirmation: this.STRINGS.dz_confirma_cancelar_envio,
      dictInvalidFileType: this.STRINGS.dz_arquivo_invalido,
      maxFiles: 1,
      transformFile: (file, done) => {
        this.cropCheckInterval = setInterval(() => { if (this.helpers.getLocallyStored('cropOngoing') === false) this.resetDropzoneUploads() }, 250);
        this.helpers.cropImage(file, done, 'dropzone-workout-cover', 300, 300);
      }
      // autoProcessQueue: false,
    };
  }

  getRequiredMessage(el: any) {
    if (el.hasError('required')) {
      return this.STRINGS.campo_obrigatorio;
    }

    if (el.hasError('incorrect')) {
      return this.STRINGS.campo_invalido;
    }
  }

  ngOnInit() {
    this.updateModernLayoutTheme(normalizeLayoutTheme(localStorage.getItem(LAYOUT_THEME_STORAGE_KEY)));
    this.layoutThemeSubscription = layoutThemeChanges$.subscribe((theme: string) => this.updateModernLayoutTheme(theme));
    this.loading = false;
    this.showSerieForm = false;
    this.serieForm.reset();
    this.user = JSON.parse(localStorage.getItem('user'));
    // this.getWorkouts(this.training_id);
    this.config.dictDefaultMessage = ((this.ismobile  || this.istablet)
        ? this.PAGE.click_enviar_banner
        : this.PAGE.arraste_banner
    )
  }

  ngOnDestroy() {
    if (this.layoutThemeSubscription) {
      this.layoutThemeSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.workout = {};

    if (this.reset === true) {
      setTimeout(() => {
        this.goBack(false);
        return true;
      },25);
      return;
    } else {
      if (this.workout_id > 0) {
        this.training_id = 0;
        this.getWorkout(this.workout_id);
        // console.log('wid > 0');
      }
      if (this.workout_id === -1) {
        this.training_id = 0;
        this.selected_workouts = [];
        this.total_selected = 0;
    this.prepareForm(false);
    this.call_form = 0;
        // console.log('wid = -1');
      }
      if (this.cloned_library) {
        this.setClonedForm(this.cloned_library);
        // console.log('cloned lib');
        // console.log(this.cloned_library);
      }
    }

    const trainingChanged = !!changes.training_id
      && changes.training_id.currentValue !== undefined
      && changes.training_id.currentValue !== null
      && changes.training_id.currentValue !== 0
      && changes.training_id.currentValue !== this.lastLoadedTid;

    if (trainingChanged && this.selected_workout === 0) {
      this.getWorkouts(this.training_id);
      this.lastLoadedTid = this.training_id;
      this.needsReload = false;
    }

    if (changes.opened_library && changes.opened_library.previousValue === true && this.opened_library === false) {
      const needReload = this.helpers.getLocallyStored('workoutsNeedReload');
      if (needReload) {
        this.helpers.deleteLocallyStored('workoutsNeedReload');
        this.getWorkouts(this.training_id);
        this.lastLoadedTid = this.training_id;
        this.needsReload = false;
      }
    }
  }


  resetMobileToList() {
    this.selected_workout = 0;
    this.selected_workouts = [];
    this.total_selected = 0;
    this.call_form = 0;
    this.showSerieForm = false;
    this.serieForm.reset();
    this.workout_id = 0;
    this.workout = this.helpers.resetObject(this.workout);
    this.sanitized_video_url = '';
    this.lastLoadedTid = null;
    this.needsReload = false;
  }

  goBack(reload: boolean = true) {
    // this.opened_library = false;
    this.closeLibrary();
    this.loading = false;
    this.selected_workout = 0;
    this.total_selected = 0;
    this.selected_workouts = [];
    this.call_form = 0;
    this.workout_id = 0;
    this.workout = this.helpers.resetObject(this.workout);
    this.prepareForm(false);
    this.call_form = 0;
    if (this.needsReload === true) reload = true;
    if (reload && this.needsReload) this.getWorkouts(this.training_id);
  }

  getWorkouts(tid: any) {
    if (this.training_id === 0 || tid === undefined) {
      return;
    }
    this.lastLoadedTid = tid;
    this.needsReload = false;
    this.workouts = [];

    this.loading = true;
    this.workoutProvider.workouts(tid).then(
      (res: any) => {
        this.workouts = res.workouts;
        this.total_workouts = res.total_workouts_not_merged;
        this.call_form = 0;
        for (let i = 0; i < this.workouts.length; i++) {
          this.selected_workouts[i] = false;
          if (!this.workouts[i].is_serie) {
            this.total_workouts_without_series++;
          }
        }

        this.loading = false;
        if(this.checkAll) {
          this.checkAll.indeterminate = false;
          this.checkAll.checked = false;
        }
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
      });
  }

  selectWorkout(id: any) {
    this.selected_workout = id;
    this.call_form = 1;
  }

  getWorkout(id: any) {
    if (this.training_id === null) {
      if (this.workout_id === 0) {
        this.setWorkoutId.emit(id);
        return;
      }
      id = this.workout_id;
    }

    this.call_form = 1;
    this.loading = true;

    this.workoutProvider.workout(id).then(
      (res: any) => {
        this.workout = res.workout;
        this.selected_workout = this.workout.id;

        // this.sanitized_video_url = this.helpers.sanitizerVideoURL(this.workout.video_url);
        if (this.workout.video_url === null || this.workout.video_url === '' || this.workout.video_url === 'https://player.vimeo.com/video/') {
          this.workout.video_url = 'https://player.vimeo.com/video/';
          this.sanitized_video_url = '';
        }

        if (this.workout.video_url !== 'https://player.vimeo.com/video/' && this.workout.video_url !== null && this.workout.video_url !== '') {
          this.sanitized_video_url = this.helpers.sanitizerVideoURL(this.workout.video_url);
        }

        if (this.workout.video_url === null) {
          this.workout.video_url = 'https://player.vimeo.com/video/';
        }

        this.config.headers = this.headers;

        this.config.url = this.api.API_URL + '/v2/workouts/' + id;
        this.config.params = {
          '_method': 'patch',
          'name': this.workout.name,
          'video_url': this.workout.video_url,
          'training_id': this.workout.training_id,
        };
        this.loading = false;
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
      });
  }

  addWorkout() {
    // console.log('addWorkout:');
    this.selected_workout = -1;
    this.opened_library = false;
    if (this.training_id === null) {
      if (this.workout_id === 0) {
        this.setWorkoutId.emit(-1);
        return;
      }
    }
    this.prepareForm();
  }

  prepareForm(setCallForm: boolean = true) {
    if (setCallForm) {
      this.call_form = 1;
    }
    this.sanitized_video_url = '';
    this.workout = this.helpers.resetObject(this.workout);
    this.workout.training_id = (this.training_id === null) ? 0 : this.training_id;
    this.workout.cover_url = this.API + 'img/EXERCICIO-BANNER-PADRAO.jpg';
    this.workout.video_url = 'https://player.vimeo.com/video/';
    this.workout.intervals = null;
    this.workoutName.reset();
    this.workoutVideoUrl.reset();
    this.workoutVideoUrl.setValue('https://player.vimeo.com/video/');
  }

  saveWorkout() {
    this.closeLibrary();
    let valid = true;
    let el: any;
    this.updateTranslation();
    
    valid = this.validateForm();
    
    if (valid === false) {
      // el = document.getElementById('iframeWorkoutVideo');
      // el.scrollIntoView();
      return false;
    }
    
    this.loading = true;
    if (this.workout.id > 0) {
      this.updateWorkout();
    }
    if (this.workout.id === undefined || this.workout.id === 0) {
      this.createWorkout();
    }
  }

  updateWorkout() {
    const workoutUploaded = this.workout;
    delete workoutUploaded.cover_path;
    delete workoutUploaded.cover_url;
    workoutUploaded.goal = this.workout.goal;

    this.workoutProvider.patchWorkout(workoutUploaded).then(
      (res: any) => {
        this.workout = res.workout;
        this.toastr.success(this.PAGE.atualizado_sucesso, '', this.helpers.toastrCfgs);
        // this.loading = false;
        this.needsReload = true;
        this.goBack();
      },
      (err: any) => {
        console.log(err);
        this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        // this.loading = false;
        // this.goBack();
      });
  }

  createWorkout() {
    this.workoutProvider.postWorkout(this.workout).then(
      (res: any) => {
        this.workout = res.workout;
        this.toastr.success(this.PAGE.cadastrado_sucesso, '', this.helpers.toastrCfgs);
        this.cloned_library = null;
        this.loading = false;
        this.needsReload = true;
        this.goBack();
      },
      (err: any) => {
        console.log(err);
        this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        this.loading = false;
      });
  }

  deleteWorkout(id = null) {
    this.deleteWorkoutConfirmation(id);
  }

  deleteWorkoutConfirmation(id: any): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: this.PAGE.apagar_exercicio_title, message: this.PAGE.apagar_exercicio, confirmation: 'deletar'}
    });

    if (id === null) { id = this.workout.id; }

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed: ' + result);
      if (result === 'deletar') {
        this.loading = true;
        this.workoutProvider.deleteWorkout(id).then(
          (_res: any) => {
            this.needsReload = true;
            this.goBack();
            this.toastr.success(this.PAGE.apagar_exercicio_sucesso, '', this.helpers.toastrCfgs);
          },
          (err: any) => {
            console.log(err);
            this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
            this.loading = false;
          });
      }
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    // console.log(event.previousIndex);
    // console.log(event.currentIndex);
    moveItemInArray(this.workouts, event.previousIndex, event.currentIndex);
    this.workoutReorder(this.workouts);
  }

  workoutOrderUp(_workout: any, index = 0) {
    // this.workoutOrder(workout, 'up');
    this.loading = true;
    moveItemInArray(this.workouts, index, index-1);
    this.workoutReorder(this.workouts);
  }

  workoutOrderDown(_workout: any, index = 0) {
    // this.workoutOrder(workout, 'down');
    this.loading = true;
    moveItemInArray(this.workouts, index, index+1);
    this.workoutReorder(this.workouts);
  }

  workoutOrder(workout: any, order: any) {
    delete workout.cover_path;
    delete workout.cover_url;
    workout._order = order;

    this.loading = true;
    this.workoutProvider.patchWorkout(workout).then(
      (_res: any) => {
        this.toastr.success(this.PAGE.reordenar_exercicio_sucesso, '', this.helpers.toastrCfgs);
        this.needsReload = true;
        this.goBack();
      },
      (err: any) => {
        console.log(err);
        this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        this.loading = false;
        // this.goBack();
      });
  }

  workoutReorder(workouts: any) {
    let workouts_list = new Array;
    Object.assign(workouts_list, workouts);
    // console.log(workouts_list);

    this.workoutProvider.reorderWorkout(workouts_list.reverse()).then(
      (_res: any) => {
        this.loading = false;
        this.toastr.success(this.PAGE.reordenar_exercicios_sucesso, '', this.helpers.toastrCfgs);
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
        this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
      });
  }


  // dropzone events
  changeWorkoutName() {
    this.resetDropzoneUploads();
    this.updateDropzoneParams();
  }

  changeWorkoutVideoUrl() {
    this.resetDropzoneUploads();
    this.updateDropzoneParams();
    this.sanitized_video_url = '';
    if (this.workout.video_url !== '' && this.workout.video_url !== null && this.workout.video_url !== 'https://player.vimeo.com/video/') {
      this.sanitized_video_url = this.helpers.sanitizerVideoURL(this.workout.video_url);
      this.workout.video_url = this.workout.video_url.replace('shorts/', 'watch?v=');
    }

  }

  onAddedFile(_args: any) {
    // console.log('adicionando arquivo...');
    let valid = true;
    if (this.workout.name === '') {
      this.loading = false;
      this.resetDropzoneUploads();
      valid = false;
      this.workoutName.markAsTouched();
    }
    if (this.workout.video_url === '') {
      this.loading = false;
      this.resetDropzoneUploads();
      valid = false;
      this.workoutVideoUrl.markAsTouched();
    }
    if (valid === false) {
      return false;
    }
  }

  onSendingFile(_$event: any) {
    this.workout.cover_path = '';
    this.workout.cover_url = false;
  }

  onRemovedFile(_$event: any) {
    //
  }

  onUploadError(_$event: any) {
    console.log('upload error');
    console.log(_$event);
  }

  onUploadSuccess($event: any) {
    this.loading = false;
    // this.workout = $event[1].workout;
    this.workout.id = $event[1].workout.id;
    this.workout.cover_url = $event[1].workout.cover_url;
    this.workout.sort = $event[1].workout.sort;
    this.toastr.success(this.PAGE.banner_upload_sucesso, '', this.helpers.toastrCfgs);

    this.resetDropzoneUploads();
    this.config.url = this.api.API_URL + '/v2/workouts/' + this.workout.id;
    this.config.params = {
      '_method': 'patch',
      'name': this.workout.name,
      'video_url': this.workout.video_url,
      'training_id': this.workout.training_id,
    };
  }

  resetDropzoneUploads(): void {
    this.helpers.deleteLocallyStored('cropOngoing');
    clearInterval(this.cropCheckInterval);
    if (this.dzWorkoutCover && this.dzWorkoutCover.directiveRef) {
      this.dzWorkoutCover.directiveRef.reset(true);
    }
  }

  updateDropzoneParams(): void {
    this.config.headers = this.headers;

    this.config.params = {
      'name': this.workout.name,
      'video_url': this.workout.video_url,
      'training_id': this.workout.training_id,
    };

    if (this.workout.id > 0) {
      this.config.url = this.api.API_URL + '/v2/workouts/' + this.workout.id;
      this.config.params._method = 'PATCH';
    } else {
      this.config.url = this.api.API_URL + '/v2/workouts/';
    }
  }


  closeLibrary() {
    this.setOpenLibrary.emit(false);
    this.opened_library = false;
    this.helpers.deleteLocallyStored('workoutsLimit');
  }

  openLibrary() {
    this.setOpenLibrary.emit(true);
    this.helpers.storeLocally('workoutsLimit', this.getWorkoutsLimit());
    // this.loadLibrary();
  }

  getWorkoutsLimit() {
    const limit = 25 - this.total_workouts;
    return limit;
  }

  loadLibrary() {
    this.loadingLibrary = true;

    this.libraryProvider.library().then(
      (res: any) => {
        this.library = res.workouts;
        this.loadingLibrary = false;
      },
      (err: any) => {
        console.log(err);
        this.loadingLibrary = false;
      });
  }

  setClonedForm(cloned: any = null) {
    if (cloned.length !== null) {
      this.addWorkout();
      this.workout = Object.assign({}, cloned);
      this.workout.training_id = this.training_id;
      this.workout.library_workout_id = cloned.id;
      this.workout.id = 0;
      this.workoutName.setValue(cloned.name);
      this.workoutVideoUrl.setValue(this.workout.video_url);
      if (this.workout.video_url === '' || this.workout.video_url === null) {
        this.workout.video_url = 'https://player.vimeo.com/video/';
        this.workoutVideoUrl.setValue('https://player.vimeo.com/video/');
      }
      this.changeWorkoutVideoUrl();
      this.updateDropzoneParams();
    }
  }

  validateForm() {
    // console.log(this.workout);
    let valid = true;
    if (this.workout.name === '') {
      this.workoutName.markAsTouched();
      valid = false;
    }
    if (this.workout.video_url === '') {
      this.workoutVideoUrl.markAsTouched();
      valid = false;
    }
    if (this.helpers.validateURL(this.workout.video_url)) {
      this.workoutVideoUrl.setErrors({'incorrect': true});
      valid = false;
    }
    if (!(/^\d+$/.test(this.workout.intervals))) {
      if (this.workout.intervals !== null && this.workout.intervals !== '') {
        this.toastr.error(this.PAGE.campo_intervalo, '', this.helpers.toastrCfgs);
        valid = false;
      } else {
        this.workout.intervals = 0;
      }
    }

    return valid;
  }


  // funcoes para series de exercicios
  addSerie() {
    this.showSerieForm = true;
    this.serieForm.reset();
    this.serieForm.patchValue({ id: 0, color: '#707070', training_id: this.training_id });
    if (this.modernLayoutTheme) {
      this.serieForm.patchValue({ selected: '0', translations: '' });
      this.selectSerieMethod(this.serieMethods[0]);
    }
    this.setSelectedWorkoutsToSerie();
  }

  editSerie(serie: any) {
    this.selected_workout = 0;
    this.total_selected = 0;
    this.selected_workouts = [];
    if (this.checkAll) {
      this.checkAll.indeterminate = false;
      this.checkAll.checked = false;
    }

    this.showSerieForm = true;
    this.serieForm.reset();
    this.serieForm.patchValue(serie);
    if (this.modernLayoutTheme) {
      this.selectedSerieMethod = this.findSerieMethod(serie && serie.name);
    }
  }

  selectSerieMethod(method: any) {
    this.selectedSerieMethod = method;
    const isCustom = method.key === 'custom';
    this.serieForm.patchValue({
      name: isCustom ? '' : method.names[0],
      description: isCustom ? '' : method.descriptions[0].text,
      color: method.color,
      translations: '',
    });
  }

  selectSerieName(name: string) {
    this.serieForm.patchValue({ name: name });
    this.clearSerieTranslation('name');
  }

  selectSerieDescription(description: string) {
    this.serieForm.patchValue({ description: description });
    this.clearSerieTranslation('description');
  }

  selectSerieColor(color: string) {
    this.serieForm.patchValue({ color: color });
  }

  onSerieFieldInput(field: string) {
    this.clearSerieTranslation(field);
  }

  openModernSerieTranslation(label: string, field: string, limit: number) {
    const values = Object.assign({}, this.serieForm.value);
    const preset = this.getSeriePresetTranslation(values[field]);

    if (preset) {
      let seeded: any = { strings_en: {}, strings_es: {} };
      try {
        seeded = values.translations ? JSON.parse(values.translations) : seeded;
      } catch (_error) {}
      seeded.strings_en = seeded.strings_en || {};
      seeded.strings_es = seeded.strings_es || {};
      if (!seeded.strings_en[field]) seeded.strings_en[field] = preset.en;
      if (!seeded.strings_es[field]) seeded.strings_es[field] = preset.es;
      values.translations = JSON.stringify(seeded);
    }

    this.helpers.callTranslation(label, field, values, limit, (result: any) => {
      this.processTranslationSerie(result);
      if (result) {
        this.serieForm.patchValue({ translations: JSON.stringify(result) });
      }
    });
  }

  hasSerieTranslation(field: string): boolean {
    const translations = this.serieForm.value.translations;
    if (!translations) return false;

    try {
      const parsed = typeof translations === 'string' ? JSON.parse(translations) : translations;
      return !!((parsed.strings_en && parsed.strings_en[field]) || (parsed.strings_es && parsed.strings_es[field]));
    } catch (_error) {
      return false;
    }
  }

  serieSelectedCount(serie: any = null): number {
    let count = this.workouts.filter((workout: any) => !workout.is_serie && workout.serie_check === true).length;
    if (serie && serie.workouts) {
      count += serie.workouts.filter((workout: any) => workout.serie_check === true).length;
    }
    return count;
  }

  private updateModernLayoutTheme(theme: string) {
    this.modernLayoutTheme = isModernLayoutTheme(theme);
  }

  private findSerieMethod(name: string): any {
    return this.serieMethods.find((method: any) => method.names.indexOf(name) !== -1) || this.serieMethods[this.serieMethods.length - 1];
  }

  private clearSerieTranslation(field: string) {
    const translations = this.serieForm.value.translations;
    if (!translations) return;

    try {
      const parsed = typeof translations === 'string' ? JSON.parse(translations) : translations;
      if (parsed.strings_en) parsed.strings_en[field] = '';
      if (parsed.strings_es) parsed.strings_es[field] = '';
      this.serieForm.patchValue({ translations: JSON.stringify(parsed) });
    } catch (_error) {
      this.serieForm.patchValue({ translations: '' });
    }
  }

  private getSeriePresetTranslation(text: string): any {
    const translations: any = {
      'Super-Série': { en: 'Super-Set', es: 'Superserie' },
      'Super-Série Antagonista': { en: 'Antagonist Super-Set', es: 'Superserie Antagonista' },
      'Super-Série A': { en: 'Super-Set A', es: 'Superserie A' },
      'Bi-Set': { en: 'Bi-Set', es: 'Bi-Set' },
      'Bi-Set Mesmo Grupo': { en: 'Bi-Set Same Muscle Group', es: 'Bi-Set Mismo Grupo' },
      'Bi-Set Pré-Exaustão': { en: 'Bi-Set Pre-Exhaustion', es: 'Bi-Set Pre-Agotamiento' },
      'Tri-Set': { en: 'Tri-Set', es: 'Tri-Set' },
      'Tri-Set Membros Superiores': { en: 'Tri-Set Upper Body', es: 'Tri-Set Tren Superior' },
      'Tri-Set Membros Inferiores': { en: 'Tri-Set Lower Body', es: 'Tri-Set Tren Inferior' },
      'Giant-Set': { en: 'Giant-Set', es: 'Giant-Set' },
      'Giant-Set Circuito de Força': { en: 'Giant-Set Strength Circuit', es: 'Giant-Set Circuito de Fuerza' },
      'Circuito de Exercícios': { en: 'Exercise Circuit', es: 'Circuito de Ejercicios' },
      'Circuito Metabólico': { en: 'Metabolic Circuit', es: 'Circuito Metabólico' },
      'Circuito Funcional': { en: 'Functional Circuit', es: 'Circuito Funcional' },
      'Sessão de Alongamento': { en: 'Stretching Session', es: 'Sesión de Estiramiento' },
      'Mobilidade e Flexibilidade': { en: 'Mobility & Flexibility', es: 'Movilidad y Flexibilidad' },
      'Drop-Set': { en: 'Drop-Set', es: 'Drop-Set (Serie Descendente)' },
      'Série Isométrica': { en: 'Isometric Series', es: 'Serie Isométrica' },
      'Execute os exercícios em sequência sem descanso entre eles. Descanse apenas após concluir todos os exercícios do grupo.': {
        en: 'Perform the exercises back to back with no rest between them. Rest only after completing all exercises in the group.',
        es: 'Realiza los ejercicios en secuencia sin descanso entre ellos. Descansa solo después de completar todos los ejercicios del grupo.'
      },
      'Dois exercícios de grupos musculares antagonistas, executados um após o outro sem pausa. O intervalo indicado vale para depois de completar a dupla.': {
        en: 'Two exercises for antagonist muscle groups, performed one right after the other with no pause. The listed rest applies after finishing the pair.',
        es: 'Dos ejercicios de grupos musculares antagonistas, realizados uno tras otro sin pausa. El descanso indicado se aplica después de completar el par.'
      },
      'Sem descanso entre os exercícios. Descanse só ao final da dupla.': {
        en: 'No rest between exercises. Rest only at the end of the pair.',
        es: 'Sin descanso entre los ejercicios. Descansa solo al final del par.'
      },
      'Execute 2 exercícios consecutivos sem intervalo entre eles. Ótimo para aumentar o volume e intensidade em menos tempo.': {
        en: 'Perform 2 consecutive exercises with no rest between them. Great for increasing volume and intensity in less time.',
        es: 'Realiza 2 ejercicios consecutivos sin descanso entre ellos. Ideal para aumentar el volumen e intensidad en menos tiempo.'
      },
      'Dois exercícios seguidos para o mesmo grupo muscular, sem descanso entre eles, aumentando o tempo sob tensão.': {
        en: 'Two exercises in a row for the same muscle group, with no rest between them, increasing time under tension.',
        es: 'Dos ejercicios seguidos para el mismo grupo muscular, sin descanso entre ellos, aumentando el tiempo bajo tensión.'
      },
      'Execute o primeiro exercício até a técnica começar a falhar e emende imediatamente no segundo, sem pausa.': {
        en: 'Perform the first exercise until your form starts to break down, then move straight into the second with no pause.',
        es: 'Realiza el primer ejercicio hasta que la técnica empiece a fallar y continúa de inmediato con el segundo, sin pausa.'
      },
      'Execute 3 exercícios em sequência sem descanso. Descanse somente após finalizar os 3 movimentos. Alto volume e estímulo metabólico.': {
        en: 'Perform 3 exercises in a row with no rest. Rest only after finishing all 3 movements. High volume and metabolic stimulus.',
        es: 'Realiza 3 ejercicios en secuencia sin descanso. Descansa solo después de terminar los 3 movimientos. Alto volumen y estímulo metabólico.'
      },
      'Encadeie os três exercícios sem pausa entre eles. O intervalo indicado é aplicado apenas depois de completar o trio.': {
        en: 'Chain the three exercises together with no pause between them. The listed rest is applied only after completing the trio.',
        es: 'Enlaza los tres ejercicios sin pausa entre ellos. El descanso indicado se aplica solo después de completar el trío.'
      },
      'Encadeie 4 ou mais exercícios sem pausa entre eles. Excelente para condicionamento e hipertrofia em circuito de alta densidade.': {
        en: 'Chain 4 or more exercises together with no pause between them. Excellent for conditioning and hypertrophy in a high-density circuit.',
        es: 'Enlaza 4 o más ejercicios sin pausa entre ellos. Excelente para acondicionamiento e hipertrofia en un circuito de alta densidad.'
      },
      'Quatro ou mais exercícios em sequência, sem descanso, repetindo pelo número de rounds indicado.': {
        en: 'Four or more exercises in sequence, with no rest, repeated for the indicated number of rounds.',
        es: 'Cuatro o más ejercicios en secuencia, sin descanso, repitiendo el número de rondas indicado.'
      },
      'Realize cada exercício como uma estação, avançando para o próximo com pouco ou nenhum descanso. Complete todas as estações e repita o número de voltas indicado.': {
        en: 'Treat each exercise as a station, moving to the next with little or no rest. Complete all stations and repeat for the indicated number of rounds.',
        es: 'Realiza cada ejercicio como una estación, avanzando al siguiente con poco o ningún descanso. Completa todas las estaciones y repite el número de vueltas indicado.'
      },
      'Percorra todos os exercícios em sequência formando um round. Anote o tempo ou repetições de cada round para acompanhar sua evolução.': {
        en: 'Go through all exercises in sequence to form one round. Track the time or reps of each round to monitor your progress.',
        es: 'Recorre todos los ejercicios en secuencia formando una ronda. Anota el tiempo o las repeticiones de cada ronda para seguir tu progreso.'
      },
      'Execute cada exercício com suavidade e controle, sustentando a posição pelo tempo indicado. Respire profundamente e relaxe progressivamente a musculatura.': {
        en: 'Perform each exercise gently and with control, holding the position for the indicated time. Breathe deeply and progressively relax the muscles.',
        es: 'Realiza cada ejercicio con suavidad y control, manteniendo la posición durante el tiempo indicado. Respira profundamente y relaja progresivamente la musculatura.'
      },
      'Exercícios de mobilidade articular para melhorar a amplitude de movimento. Execute sem dor, apenas até sentir o alongamento.': {
        en: 'Joint mobility exercises to improve range of motion. Perform pain-free, only up to the point of feeling the stretch.',
        es: 'Ejercicios de movilidad articular para mejorar el rango de movimiento. Realízalos sin dolor, solo hasta sentir el estiramiento.'
      },
      'Execute o exercício até a falha, reduza a carga imediatamente e continue sem descanso. Repita as reduções conforme indicado. Excelente para hipertrofia máxima.': {
        en: 'Perform the exercise to failure, immediately reduce the load and continue with no rest. Repeat the reductions as indicated. Excellent for maximum hypertrophy.',
        es: 'Realiza el ejercicio hasta el fallo, reduce la carga de inmediato y continúa sin descanso. Repite las reducciones según lo indicado. Excelente para la hipertrofia máxima.'
      },
      'Na falha, reduza o peso e continue sem descanso, repetindo o número de quedas indicado.': {
        en: 'At failure, reduce the weight and continue with no rest, repeating for the indicated number of drops.',
        es: 'Al fallar, reduce el peso y continúa sin descanso, repitiendo el número de caídas indicado.'
      },
      'Mantenha a contração muscular estática na posição indicada pelo tempo prescrito, sem mover a articulação. Foco total na tensão muscular e respiração controlada.': {
        en: 'Hold the static muscle contraction in the indicated position for the prescribed time, without moving the joint. Full focus on muscular tension and controlled breathing.',
        es: 'Mantén la contracción muscular estática en la posición indicada durante el tiempo prescrito, sin mover la articulación. Enfócate por completo en la tensión muscular y la respiración controlada.'
      },
    };

    return translations[text] || null;
  }

  setSelectedWorkoutsToSerie() {
    this.selected_workouts.map((checked: any, idx) => {
      if (checked) {
        this.workouts[idx].serie_check = true;
      }
    });
  }

  formSerieSave(serie: any = null) {
    // console.log('formSerieSave');

    if (this.serieForm.value.name === null || (this.modernLayoutTheme && !String(this.serieForm.value.name || '').trim())) {
      this.toastr.warning(this.PAGE.campo_nome_obrigatorio, '', this.helpers.toastrCfgs);
      return false;
    }

    let selected: string = this.serieForm.value.selected;
    this.showSerieForm = false;
    this.loading = true;
    this.workouts.map((workout: any) => {
      if (workout.serie_check === true) {
        selected = selected + ',' + (workout.id).toString();
      }
    });
    if (serie) {
      serie.workouts.map((workout: any) => {
        if (workout.serie_check === true) {
          selected = selected + ',' + (workout.id).toString();
        }
      });
    }
    this.serieForm.patchValue({ selected: selected });

    if (parseInt(this.serieForm.value.id) === 0) {
      this.updateTranslationSerie(0);
      this.createSerie(this.serieForm.value);
    } else {
      this.updateTranslationSerie(this.serieForm.value.id);
      this.updateSerie(this.serieForm.value);
    }
  }

  formSerieCancel() {
    this.showSerieForm = false;
  }

  createSerie(data: any) {
    this.workoutProvider.postWorkoutSerie(data).then(
      (res: any) => {
        this.workouts = res.workouts;
        this.toastr.success(this.PAGE.serie_cadastro_sucesso, '', this.helpers.toastrCfgs);
        this.loading = false;

        this.selected_workout = 0;
        this.total_selected = 0;
        this.selected_workouts = [];
        if (this.checkAll) {
          this.checkAll.indeterminate = false;
          this.checkAll.checked = false;
        }
      },
      (err: any) => {
        console.log(err);
        this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        this.loading = false;
      });
  }

  updateSerie(data: any) {
    // console.log(data);
    // this.loading = false;
    this.workoutProvider.patchWorkoutSerie(data).then(
      (res: any) => {
        this.workout = res.workout;
        this.toastr.success(this.PAGE.serie_atualizado_sucesso, '', this.helpers.toastrCfgs);
        this.needsReload = true;
        this.goBack();
      },
      (err: any) => {
        console.log(err);
        this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
      });
  }

  deleteSerie(id = null) {
    this.deleteSerieConfirmation(id);
  }

  deleteSerieConfirmation(id: any): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: this.PAGE.apagar_serie_title, message: this.PAGE.apagar_serie, confirmation: 'deletar'}
    });

    if (id === null) { id = this.workout.id; }

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'deletar') {
        this.loading = true;
        this.workoutProvider.deleteWorkoutSerie(id).then(
          (res: any) => {
            this.workouts = res.workouts;
            this.showSerieForm = false;
            this.serieForm.reset();
            this.serieForm.patchValue({ id: 0, color: '#707070', training_id: this.training_id });
            this.toastr.success(this.PAGE.apagar_serie_confirmacao_sucesso, '', this.helpers.toastrCfgs);
            this.loading = false;
          },
          (err: any) => {
            console.log(err);
            this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
            this.loading = false;
          }
        );
      }
    });
  }

  applyAll(field: string): void {
    // console.log(field);
    // console.log(this.workout);
    let data = Object.assign({}, this.workout);
    data._field = field;

    let campo: any;
    if (field === 'series_repetitions') campo = this.PAGE.series_repetition;
    if (field === 'intervals') campo = this.PAGE.interval;
    if (field === 'weight_suggestion') campo = this.PAGE.sugestao_carga_opcional;

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: this.PAGE.atualizar_exercicio_title, message: this.PAGE.atualizar_exercicio_a + ' ('+campo+') ' + this.PAGE.atualizar_exercicio_b, confirmation: 'atualizar'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'atualizar') {
        this.loading = true;
        this.workoutProvider.updateMassWorkout(data).then(
          (res: any) => {
            this.workouts = res.workouts;
            this.toastr.success(this.PAGE.atualizar_exercicio_sucesso, '', this.helpers.toastrCfgs);
            this.loading = false;
            this.needsReload = true;
            // this.goBack();
          },
          (err: any) => {
            console.log(err);
            this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
            this.loading = false;
          }
        );
      }
    });    

  }

  selectQuickWorkoutSuggestion(field: string, value: any): void {
    this.workout[field] = value;
  }

  helpIntervalo() {
    let msg = this.PAGE.ajuda_intervaloç
    const dialogRef = this.dialog.open(DialogLightComponent, { width: '360px', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }

  updateTranslation() {
    const translations = (document.getElementById('translationFieldWorkout') as HTMLInputElement).value;
    this.workout.translations = translations;
  }

  processTranslation(value: any) {
    // console.log(value);
    if (value) {
      (document.getElementById('translationFieldWorkout') as HTMLInputElement).value = JSON.stringify(value);
    }
  }

  updateTranslationSerie(serieId: number = 0) {
    const translations = (document.getElementById('translationFieldSeries' + serieId) as HTMLInputElement).value;
    this.serieForm.value.translations = translations;
  }
  processTranslationSerie(value: any) {
    // console.log(value);
    if (value) {
      (document.getElementById('translationFieldSeries' + value.id) as HTMLInputElement).value = JSON.stringify(value);
    }
  }

  helpVideo() {
    let msg = this.PAGE.ajuda_video;

    const dialogRef = this.dialog.open(DialogLightComponent, { width: '360px', data: { message: msg } });
    dialogRef.afterClosed().subscribe(_result => {});
  }

  deleteMassWorkout() {
    let arr: any = [];
    this.selected_workouts.map((checked: any, idx) => {
      if (checked) {
        arr.push(this.workouts[idx].id);
      }
    });
    this.deleteMassWorkoutConfirmation(arr);
  }

  deleteMassWorkoutConfirmation(arrIds: any): void {
    const msg = this.PAGE.apagar_exercicios;
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: this.PAGE.apagar_exercicios_title, message: msg, confirmation: 'deletar'}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed: ' + result);
      if (result === 'deletar') {
        this.setWorkoutId.emit(0);
        this.loading = true;
        this.workoutProvider.deleteMassTraining({tids: arrIds}).then(
          (_res: any) => {
            this.needsReload = true;
            this.goBack();
            this.setAll(false);
            this.toastr.success(this.PAGE.apagar_exercicios_sucesso, '', this.helpers.toastrCfgs);
          },
          (err: any) => {
            console.log(err);
            this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
            this.loading = false;
          });
      }
    });
  }

  workoutMassClone() {
    let arr: any = [];
    this.selected_workouts.map((checked: any, idx) => {
      if (checked) {
        arr.push(this.workouts[idx].id);
      }
    });
    this.cloneWorkoutConfirmation(arr);
  }

  cloneWorkoutConfirmation(arrIds: any = []): void {
    let msg = this.PAGE.clonar_exercicio;
    let confirmation = 'clonar';
    if ((this.total_workouts + arrIds.length) > this.limit) {
      msg = this.PAGE.o_limite_de + this.limit + this.PAGE.limite_exercicios;
      confirmation = 'ok'
    }

    const dialogRef = this.dialog.open(DialogComponent, {
      width: '360px',
      data: {title: this.PAGE.clonar_exercicio_title, message: msg, confirmation: confirmation}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'ok') {
        return false;
      }
      if (result === 'clonar') {
        this.loading = true;
        this.workoutProvider.cloneTraining({ids: arrIds}).then(
          (_res: any) => {
            this.needsReload = true;
            this.goBack();
            this.setAll(false);
            this.toastr.success(this.PAGE.clonar_exercicio_sucesso, '', this.helpers.toastrCfgs);
          },
          (err: any) => {
            console.log(err);
            this.toastr.warning(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
            this.loading = false;
          });
      }
    });
  }

  changeCheck(checked: boolean) {
    this.total_selected += (checked) ? + 1 : - 1;
  }

  updateAllComplete() {
    let selecteds: number = 0;
    this.selected_workouts.map((selected: boolean) => {
      if (selected) selecteds++;
    });
    if (selecteds === (this.total_workouts - this.total_workouts_without_series)) {
      this.checkAll.checked = true;
      this.checkAll.indeterminate = false;
    } else {
      if (this.selected_workouts.length > 0) {
        this.checkAll.indeterminate = true;
      }
    }
    if (selecteds === 0) {
      this.checkAll.indeterminate = false;
      this.checkAll.checked = false;
    }
  }

  setAll(checked: boolean) {
    if (this.selected_workouts == null) return;
    if (!checked) this.checkAllIndeterminate = false;
    let count: number = 0;
    for (let i = 0; i < this.workouts.length; i++) {
      if (!this.workouts[i].is_serie) {
        this.selected_workouts[i] = checked;
        count++;
      }
    }
    this.total_selected = (checked) ? count : 0;
  }

}
